/**
 * @generated SignedSource<<08a36e90d7328be4ce06ca303707f469>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type JobEstimateSourceEnum = "SYSTEM" | "USER";
export type JobScheduleStatusEnum = "AHEAD" | "DELAYED" | "ON_TIME";
export type JobStatusEnum = "CANCELLED" | "COMPLETED" | "RUNNING" | "SCHEDULED";
import { FragmentRefs } from "relay-runtime";
export type InfoBoxJobFragment_job$data = {
  readonly actualStartTime: any | null | undefined;
  readonly actualStopTime: any | null | undefined;
  readonly durations: {
    readonly delayAfterMinutes: number | null | undefined;
    readonly dynamicDurationMinutes: number | null | undefined;
    readonly plannedDurationMinutes: number | null | undefined;
  } | null | undefined;
  readonly estimateSource: JobEstimateSourceEnum | null | undefined;
  readonly estimatedStartTime: any | null | undefined;
  readonly estimatedStopTime: any | null | undefined;
  readonly events: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly happenedAt: any | null | undefined;
        readonly id: string;
        readonly type: {
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly plannedStart: any | null | undefined;
  readonly plannedStop: any | null | undefined;
  readonly scheduleStatus: JobScheduleStatusEnum | null | undefined;
  readonly status: JobStatusEnum | null | undefined;
  readonly " $fragmentType": "InfoBoxJobFragment_job";
};
export type InfoBoxJobFragment_job$key = {
  readonly " $data"?: InfoBoxJobFragment_job$data;
  readonly " $fragmentSpreads": FragmentRefs<"InfoBoxJobFragment_job">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InfoBoxJobFragment_job",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "plannedStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "plannedStop",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scheduleStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualStartTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualStopTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "estimatedStopTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "estimatedStartTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "estimateSource",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Durations",
      "kind": "LinkedField",
      "name": "durations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dynamicDurationMinutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "delayAfterMinutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "plannedDurationMinutes",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 20
        }
      ],
      "concreteType": "EventConnection",
      "kind": "LinkedField",
      "name": "events",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Event",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "happenedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EventType",
                  "kind": "LinkedField",
                  "name": "type",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "events(first:20)"
    }
  ],
  "type": "Job",
  "abstractKey": "__isJob"
};
})();

(node as any).hash = "adf688d5e1674e89d7e3ead59e3e6b6c";

export default node;
